// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import DealCard from "./DealCard";
// import { useAppSelector } from "../../../../Redux Toolkit/Store";
// import { Deal } from "../../../../types/dealTypes";

// export default function DealSlider() {
//     const {homePage}=useAppSelector(store=>store)
//     var settings = {
//         dots: true,
//         infinite: true,
//         slidesToShow: 6,
//         slidesToScroll: 1,
//         autoplay: true,
//         speed: 2000,
//         autoplaySpeed: 4000,
//         cssEase: "linear",
//         responsive: [
//             {
//               breakpoint: 1024, // Large screen
//               settings: {
//                 slidesToShow: 4,
//                 slidesToScroll: 1,
//               },
//             },
//             {
//               breakpoint: 768, // Tablet
//               settings: {
//                 slidesToShow: 2,
//                 slidesToScroll: 1,
//               },
//             },
//             {
//               breakpoint: 480, // Mobile
//               settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//               },
//             },
//           ],

//     };
//     return (
//         <div className=" py-5 lg:px-20">
//             <div className="slide-container  ">
//                 <Slider {...settings}>
//                     {homePage.homePageData?.deals?.map((item:Deal) => <div className="border flex flex-col items-center justify-center">
//                         <DealCard deal={item}/>
//                     </div>)}

//                 </Slider>
//             </div>
//         </div>

//     );
// }


// Changes to make modern website
import React from "react";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../Redux Toolkit/Store";
import { Deal } from "../../../../types/dealTypes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

type ArrowProps = {
  onClick?: () => void;
};

const PrevArrow = ({ onClick }: ArrowProps) => (
  <IconButton
    onClick={onClick}
    sx={{
      position: "absolute",
      left: { xs: 2, sm: 6, md: 10 },
      top: "38%",
      transform: "translateY(-50%)",
      zIndex: 5,
      backgroundColor: "rgba(255,255,255,0.96)",
      boxShadow: "0 8px 22px rgba(0,0,0,0.14)",
      width: { xs: 34, sm: 38, md: 42 },
      height: { xs: 34, sm: 38, md: 42 },
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    }}
  >
    <ChevronLeft />
  </IconButton>
);

const NextArrow = ({ onClick }: ArrowProps) => (
  <IconButton
    onClick={onClick}
    sx={{
      position: "absolute",
      right: { xs: 2, sm: 6, md: 10 },
      top: "38%",
      transform: "translateY(-50%)",
      zIndex: 5,
      backgroundColor: "rgba(255,255,255,0.96)",
      boxShadow: "0 8px 22px rgba(0,0,0,0.14)",
      width: { xs: 34, sm: 38, md: 42 },
      height: { xs: 34, sm: 38, md: 42 },
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    }}
  >
    <ChevronRight />
  </IconButton>
);

const getDealTitle = (item: any) => {
  return (
    item?.category?.name ||
    item?.name ||
    item?.title ||
    item?.category?.title ||
    "Limited Time Offer"
  );
};

const DealItemCard = ({ item }: { item: Deal }) => {
  const navigate = useNavigate();
  const title = getDealTitle(item);

  return (
    <div className="px-1 sm:px-1.5">
      <div
        // onClick={() => navigate(`/products/${item.category.categoryId}`)}
        onClick={() => {
          if (item?.category?.categoryId) {
            navigate(`/products/${item.category.categoryId}`);
          }
        }}
        className="group cursor-pointer overflow-hidden rounded-[16px] bg-[#061126] shadow-[0_10px_24px_rgba(2,6,23,0.12)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_30px_rgba(2,6,23,0.16)]"
      >
        <div className="relative">
          <span className="absolute left-3 top-3 z-10 rounded-lg bg-[#ef2f2f] px-3 py-1.5 text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.08em] text-white shadow-md">
            Deal of the day
          </span>

          <div className="overflow-hidden">
            <img
              className="h-[150px] sm:h-[165px] md:h-[180px] lg:h-[195px] xl:h-[210px] w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
              src={item.category.image}
              alt={title || "Deal image"}
            />
          </div>
        </div>

        <div className="bg-[#061126] px-3 py-3 sm:px-4 sm:py-4 text-white">
          <h3 className="line-clamp-2 min-h-[44px] text-base sm:text-lg lg:text-xl font-semibold leading-tight">
            {title}
          </h3>

          <div className="mt-2 flex items-end justify-between gap-2">
            <p className="text-[11px] sm:text-xs lg:text-sm text-white/75">
              Premium picks for a limited period
            </p>
            <span className="shrink-0 text-sm sm:text-base lg:text-lg font-bold text-[#fbbf24]">
              {item.discount}% OFF
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function DealSlider() {
  const { homePage } = useAppSelector((store) => store);
  const deals = homePage.homePageData?.deals || [];

  const settings = {
    dots: false,
    infinite: deals.length > 5,
    slidesToShow: Math.min(5, deals.length || 1),
    slidesToScroll: 1,
    arrows: deals.length > 1,
    autoplay: false,
    speed: 500,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        // Below 1920 -> keep 5
        breakpoint: 1920,
        settings: {
          slidesToShow: Math.min(5, deals.length || 1),
          slidesToScroll: 1,
        },
      },
      {
        // Laptop
        breakpoint: 1280,
        settings: {
          slidesToShow: Math.min(4, deals.length || 1),
          slidesToScroll: 1,
        },
      },
      {
        // Tablet
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, deals.length || 1),
          slidesToScroll: 1,
        },
      },
      {
        // Mobile
        breakpoint: 640,
        settings: {
          slidesToShow: Math.min(2, deals.length || 1),
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (!deals.length) return null;

  return (
    <section className="w-full">
      <div className="relative w-full">
        <div className="deal-slider px-1 sm:px-2 md:px-3 lg:px-4">
          <Slider {...settings}>
            {deals.map((item: Deal, index: number) => (
              <DealItemCard
                key={item.id || item.category?.categoryId || index}
                item={item}
              />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}